import { render, staticRenderFns } from "./MachineAbandoned.vue?vue&type=template&id=2d1b90d3&"
import script from "@/scripts/gpuHub/vmMachines/vmMachineAbandoned.js?vue&type=script&lang=js&"
export * from "@/scripts/gpuHub/vmMachines/vmMachineAbandoned.js?vue&type=script&lang=js&"
import style0 from "./MachineAbandoned.vue?vue&type=style&index=0&id=2d1b90d3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports